import { API, DEFAULT_API_ENDPOINTS } from 'signature-public-api-sdk';

const api = new API({
    baseUrl: '/api',
    endpoints: {
        ...DEFAULT_API_ENDPOINTS,
        login: '/login',
        logout: '/logout',

        clientDashboardInit: '/dashboard/init',

        brokerMe: '/user/me',
        brokerUpdatePassword: '/user/update-password',
        brokerDashboardStats: '/dashboard/stats',
        brokerApplications: '/applications/list?limit={limit}&page={page}',
    },
});

export default api;
